const couponsAdd = () => import('@/views/main/cash-coupons/add/add.vue')
export default {
  path: '/main/coupons/add',
  name: 'couponsAdd',
  component: couponsAdd,
  children: []
}
